interface SchedulerWithYield {
  yield?: () => Promise<void>
}

/**
 * Yield to the browser so a pending paint can flush before heavy work resumes.
 *
 * Prefers the Scheduler API (`scheduler.yield()` resumes after paint at user-visible
 * priority); where it's unavailable (non-Chromium, jsdom) falls back to a macrotask, which
 * also gives the browser a rendering opportunity between tasks. A microtask would NOT —
 * it runs before paint, so it can't be used here.
 *
 * Used to make optimistic UI feel instant: set the urgent loading/selection state, `await
 * yieldToMain()`, then run the heavy work. The YIELD (not `startTransition` alone) is what
 * unblocks the paint — `startTransition` only lowers the priority of the resulting re-render,
 * it does NOT move synchronous JS off the click task.
 */
export function yieldToMain(): Promise<void> {
  const scheduler = (globalThis as { scheduler?: SchedulerWithYield }).scheduler
  if (scheduler && typeof scheduler.yield === 'function') {
    return scheduler.yield()
  }
  return new Promise<void>(resolve => {
    setTimeout(resolve, 0)
  })
}
